import React, { useCallback } from 'react'
import useParams from 'core/hooks/useParams'
import useReactRouter from 'use-react-router'
import { routeManager } from 'core/utils/routes'
import FormFieldSection from 'core/components/validatedForm/FormFieldSection'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { createServerGroup } from './actions'
import ModalForm from 'core/elements/modal/ModalForm'
import { Route } from 'core/plugins/route'
import TextField from 'core/components/validatedForm/TextField'
import Text from 'core/elements/Text'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import PolicyPicklist from './PolicyPicklist'
import PicklistField from 'core/components/validatedForm/DropdownField'

const useStyles = makeStyles<Theme>((theme) => ({
  withUnits: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  unitsDropdown: {
    position: 'relative',
    bottom: 1,
  },
  sameLine: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
}))

interface Props {
  addRoute: Route
}

export default function CreateServerGroupModal({ addRoute }: Props) {
  const { history } = useReactRouter()
  const classes = useStyles()
  const defaultParams = {
    name: '',
    policy: 'affinity',
  }
  const { params, getParamsUpdater, updateParams, setParams } = useParams(defaultParams)

  const { update, updating, error, reset } = useUpdateAction(createServerGroup)

  const submitForm = useCallback(async () => {
    const body = {
      server_group: {
        name: params.name,
        policy: params.policy,
      },
    }
    const { success } = await update({ body })
    if (success) {
      handleClose()
    }
  }, [params])

  const handleClose = () => {
    setParams(defaultParams)
    reset()
    history.push(routeManager.routes.openstack.serverGroups.path())
  }

  return (
    <ModalForm
      route={addRoute}
      title={`Create Server Group`}
      onSubmit={submitForm}
      onClose={handleClose}
      submitting={updating}
      error={error}
      submitTitle={`Create Server Group`}
      // maxWidth={1200}
    >
      <>
        <FormFieldSection title="Server Group Configuration">
          <TextField
            id="name"
            label="Name"
            onChange={getParamsUpdater('name')}
            value={params.name}
            required
          />
          <PicklistField
            DropdownComponent={PolicyPicklist}
            id="policy"
            onChange={getParamsUpdater('policy')}
            value={params.policy}
            label="Policy"
            required
          />
        </FormFieldSection>
      </>
    </ModalForm>
  )
}
